import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product } from '@shared/models';
import { NgClass } from '@angular/common';
import { ProductCatalogueDirective } from '../product-image/product-catalogue.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: '[app-product-thumbnail]',
    templateUrl: './product-thumbnail.component.html',
    styleUrls: ['./product-thumbnail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, ProductCatalogueDirective, TranslatePipe],
})
export class ProductThumbnailComponent {
    private activatedRoute = inject(ActivatedRoute);

    categorySlug = this.activatedRoute.snapshot.params['slug'];
    url?: string;
    @Input() product!: Product;
    @Input() size = 'm';
    @Input() border = false;

    isNameNum(name: string): boolean {
        return !isNaN(parseInt(name));
    }
}
